import { render, staticRenderFns } from "./VideoTourWidget.vue?vue&type=template&id=85bc4362"
import script from "./VideoTourWidget.vue?vue&type=script&lang=js"
export * from "./VideoTourWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports